/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigDecimal: { input: number; output: number; }
  Date: { input: Date | string; output: Date; }
  DateTime: { input: Date; output: Date; }
  Long: { input: number; output: number; }
  UUID: { input: string; output: string; }
};

export enum AssetVersion {
  Original = 'ORIGINAL',
  Preview = 'PREVIEW',
  Thumbnail = 'THUMBNAIL'
}

export type BusinessModel = {
  __typename?: 'BusinessModel';
  businessModelDisplayName: Scalars['String']['output'];
  businessModelNumber: Scalars['Long']['output'];
  businessModelTypeName: Scalars['String']['output'];
};

/**  A collection that styles can belong to, e.g. a seasonal or thematic grouping.  */
export type Collection = {
  __typename?: 'Collection';
  /**  Brand number the collection belongs to.  */
  brandNumber?: Maybe<Scalars['String']['output']>;
  /**  Display name of the collection.  */
  collectionName?: Maybe<Scalars['String']['output']>;
  /**  Unique identifier of the collection.  */
  collectionNumber?: Maybe<Scalars['Long']['output']>;
  /**  Season or term the collection belongs to, e.g. "SS26".  */
  collectionTerm?: Maybe<Scalars['String']['output']>;
};

/**  Result returned for each requested style copy. */
export type CopiedStyleResponse = {
  __typename?: 'CopiedStyleResponse';
  /**  Outcome of the copy for this style. */
  generalResponse: GeneralResponse;
  /**  Name used for the copied style, or the requested name if the copy failed. */
  newStyleName?: Maybe<Scalars['String']['output']>;
  /**  Number assigned to the copied style. Null when the copy failed. */
  newStyleNumber?: Maybe<Scalars['Long']['output']>;
  /**  Name of the source style that was copied. */
  originalStyleName?: Maybe<Scalars['String']['output']>;
  /**  Number of the source style that was copied. */
  originalStyleNumber: Scalars['Long']['output'];
  /**  Relation between the source and the copied style. */
  relation: Scalars['String']['output'];
};

/**  Input describing the source style and replacement name. */
export type CopyStyleInput = {
  /**  Optional name for the copied style. */
  newStyleName?: InputMaybe<Scalars['String']['input']>;
  /**  Type of relation to create between the source style and its copy. */
  relationType?: StyleCopyRelationType;
  /**  Number of the source style. */
  styleNumber: Scalars['Long']['input'];
};

/**  Input for copying styles into one or more collections. */
export type CopyStylesInput = {
  /**  Basic Data number assigned to copied body types. */
  bodyTypeNumber?: InputMaybe<Scalars['Long']['input']>;
  /**  Brand that owns the copied styles. */
  brandNumber: Scalars['String']['input'];
  /**  Collections that receive the copied styles. */
  collectionNumbers: Array<Scalars['Long']['input']>;
  /**  Styles to copy. */
  styles: Array<CopyStyleInput>;
};

/**
 * The validation result for a single EAN submitted to the validateEans query.
 * One result is returned per submitted EAN, preserving the original input order.
 */
export type EanValidationResult = {
  __typename?: 'EanValidationResult';
  /**  The EAN number exactly as it was submitted in the request.  */
  eanNumber: Scalars['String']['output'];
  /**
   * Whether the EAN is valid for the requested brand.
   * True only when the EAN is a valid numeric value AND it exists in the database
   * for the given brand. False if the format is wrong or the EAN is not found.
   */
  isValid: Scalars['Boolean']['output'];
};

/**  Standard response for operations that return a status and messages. */
export type GeneralResponse = {
  __typename?: 'GeneralResponse';
  /**  Messages returned by the operation. */
  messages: Array<Scalars['String']['output']>;
  /**  Overall operation status. */
  status: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /**  Copies styles to the requested collections. */
  copyStyles: Array<CopiedStyleResponse>;
  /**  Updates the status and/or purchaser for multiple styles.  */
  massUpdateStyles: GeneralResponse;
  /**  Adds multiple styles to multiple collections. */
  massUpdateStylesInCollections: GeneralResponse;
  removeStyleCollections: Array<StyleCollectionResponse>;
  /**  Creates or updates a style. */
  saveStyle: StyleResponse;
  /**  Creates or updates a style grouping and an optional collection association. */
  saveStyleGrouping: GeneralResponse;
  saveStyleOptionsInCollections: GeneralResponse;
  /**  Creates or updates suppliers assigned to a style. */
  saveStyleSuppliers?: Maybe<Array<StyleSupplierResponse>>;
  /**  Creates or updates a style variant. */
  saveStyleVariant: GeneralResponse;
  /**  Creates or updates a variant. */
  saveVariant: VariantResponse;
};


export type MutationCopyStylesArgs = {
  input: CopyStylesInput;
};


export type MutationMassUpdateStylesArgs = {
  input: PatchStyleInput;
  styleNumbers: Array<Scalars['Long']['input']>;
};


export type MutationMassUpdateStylesInCollectionsArgs = {
  brandNumber: Scalars['String']['input'];
  collectionNumbers: Array<Scalars['Long']['input']>;
  styleNumbers: Array<Scalars['Long']['input']>;
};


export type MutationRemoveStyleCollectionsArgs = {
  collectionNumber: Scalars['String']['input'];
  styleNumbers: Array<Scalars['Long']['input']>;
};


export type MutationSaveStyleArgs = {
  input: StyleCreationInput;
};


export type MutationSaveStyleGroupingArgs = {
  input: SaveStyleGroupingInput;
};


export type MutationSaveStyleOptionsInCollectionsArgs = {
  saveStyleOptionsInCollections: Array<SaveStyleOptionsInCollectionsInput>;
  sizeTypePublicId: Scalars['UUID']['input'];
  styleNumber: Scalars['Long']['input'];
  userNumber: Scalars['UUID']['input'];
};


export type MutationSaveStyleSuppliersArgs = {
  styleSupplierInput?: InputMaybe<StyleSupplierInput>;
};


export type MutationSaveStyleVariantArgs = {
  input: SaveStyleVariantInput;
};


export type MutationSaveVariantArgs = {
  input: SaveVariantInput;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PaginationInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};

/**  Fields that can be updated for one or more styles.  */
export type PatchStyleInput = {
  /**  Public ID of the purchaser assigned to the styles.  */
  purchaser?: InputMaybe<Scalars['UUID']['input']>;
  /**  New lifecycle status for the styles.  */
  status?: InputMaybe<StyleStatus>;
};

export type Picture = {
  __typename?: 'Picture';
  assetVersion: AssetVersion;
  perspective?: Maybe<Scalars['String']['output']>;
  photoSequenceNumber: Scalars['Int']['output'];
  productAssetType: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  /**  Returns all available business models. */
  businessModels: Array<BusinessModel>;
  collections: Array<Collection>;
  /**  Returns all options assigned to a style. */
  getAllStyleOptionsInCollections: Array<GetAllStyleOptionsInCollection>;
  /**  Returns EANs for the requested styles in a collection. */
  getStyleEanForStyle: Array<SampleStyle>;
  /**  Returns style options and collections for the writer view. */
  getStyleOptionInCollectionsWriter?: Maybe<WriterStyleOptionsInCollectionsResponse>;
  getStyleOptionPictures: Array<Maybe<StylePicture>>;
  /**  Returns all style variant types. */
  getStyleVariantTypes: Array<StyleVariantTypeResponse>;
  /**  Query to get all style, option and ean information to be used in sample creation.  */
  getStylesForSample?: Maybe<SampleStyleConnection>;
  /**  Returns variants for a brand. */
  getVariants: Array<VariantResponse>;
  /**  Returns variants that can be assigned to a style. */
  getVariantsAvailableForStyle: VariantsAvailableForStyle;
  /**  Returns a style by its number. */
  style?: Maybe<StyleResponse>;
  /**
   * Returns style-collection associations for a brand, filtered by collection or style numbers.
   * Supply styleNumbers to find all collections a given set of styles belongs to.
   */
  styleCollection?: Maybe<StyleCollectionConnection>;
  /**  Returns active style groupings for a brand and grouping type code.  */
  styleGrouping: Array<StyleGroupingResponse>;
  /**  Returns active style grouping types.  */
  styleGroupingType: Array<StyleGroupingTypeResponse>;
  /**  Returns style names that match the exception search. */
  styleNameExceptions?: Maybe<Array<StyleNameException>>;
  /**  Searches styles using filters and cursor pagination. */
  styleSearch?: Maybe<StyleConnection>;
  /**  Returns suppliers assigned to a style. */
  styleSuppliers: Array<StyleSupplierResponse>;
  /**  Validates a list of complete EAN numbers against a selected brand. Returns one result per submitted EAN, in the same order as the input list.  */
  validateEans: Array<EanValidationResult>;
};


export type QueryCollectionsArgs = {
  styleNumbers: Array<Scalars['Long']['input']>;
};


export type QueryGetAllStyleOptionsInCollectionsArgs = {
  styleNumber: Scalars['Long']['input'];
};


export type QueryGetStyleEanForStyleArgs = {
  collectionNumber: Scalars['Long']['input'];
  styleNumbers: Array<Scalars['Long']['input']>;
};


export type QueryGetStyleOptionInCollectionsWriterArgs = {
  styleEanNumbers?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  styleNumber: Scalars['Long']['input'];
  styleOptionCollectionNumbers?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  styleOptionCollectionStyleEanNumbers?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  styleOptionNumbers?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  styleVariantNumbers?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};


export type QueryGetStyleOptionPicturesArgs = {
  styleNumber: Scalars['Long']['input'];
};


export type QueryGetStylesForSampleArgs = {
  collectionNumber: Scalars['Long']['input'];
  filters?: InputMaybe<SampleFilterInput>;
  pagination: PaginationInput;
  supplierNumber: Scalars['String']['input'];
};


export type QueryGetVariantsArgs = {
  brandNumber: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  styleVariantTypePublicId?: InputMaybe<Scalars['Long']['input']>;
};


export type QueryGetVariantsAvailableForStyleArgs = {
  brandNumber: Scalars['String']['input'];
  styleNumber: Scalars['Long']['input'];
};


export type QueryStyleArgs = {
  styleNumber: Scalars['Long']['input'];
};


export type QueryStyleCollectionArgs = {
  brandNumber: Scalars['String']['input'];
  filters: StyleCollectionFilterInput;
  pagination: PaginationInput;
};


export type QueryStyleGroupingArgs = {
  brandNumber: Scalars['String']['input'];
  styleGroupingTypeCode: StyleGroupingTypeCode;
};


export type QueryStyleNameExceptionsArgs = {
  styleNameException?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStyleSearchArgs = {
  filters?: InputMaybe<StyleFilterInput>;
  generalQuery?: InputMaybe<Scalars['String']['input']>;
  pagination: PaginationInput;
  sortBy?: InputMaybe<SortByInput>;
};


export type QueryStyleSuppliersArgs = {
  styleNumber: Scalars['Long']['input'];
};


export type QueryValidateEansArgs = {
  brandNumber: Scalars['String']['input'];
  eanNumbers: Array<Scalars['String']['input']>;
};

export type SampleFilterInput = {
  businessModelNumbers?: InputMaybe<Array<Scalars['Long']['input']>>;
  buyerNumbers?: InputMaybe<Array<Scalars['UUID']['input']>>;
  masterStyleCategoryNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  productLineNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  purchaseDivisionNumbers?: InputMaybe<Array<Scalars['Long']['input']>>;
  strategicTypeNumbers?: InputMaybe<Array<Scalars['Long']['input']>>;
  styleNumbers?: InputMaybe<Array<Scalars['Long']['input']>>;
};

export type SampleStyle = {
  __typename?: 'SampleStyle';
  masterStyleSubCategoryNumber: Scalars['String']['output'];
  productLineNumber: Scalars['String']['output'];
  styleName: Scalars['String']['output'];
  styleNumber: Scalars['Long']['output'];
  styleOptions: Array<SampleStyleOption>;
};

export type SampleStyleConnection = {
  __typename?: 'SampleStyleConnection';
  edges?: Maybe<Array<Maybe<SampleStyleEdge>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Int']['output'];
};

export type SampleStyleEan = {
  __typename?: 'SampleStyleEan';
  length?: Maybe<StyleAttribute>;
  size: StyleAttribute;
  styleEanNumber: Scalars['Long']['output'];
};

export type SampleStyleEdge = {
  __typename?: 'SampleStyleEdge';
  cursor: Scalars['String']['output'];
  node: SampleStyle;
};

export type SampleStyleOption = {
  __typename?: 'SampleStyleOption';
  businessModel: BusinessModel;
  colourName: Scalars['String']['output'];
  hexCode?: Maybe<Scalars['String']['output']>;
  styleEans: Array<SampleStyleEan>;
  styleOptionNumber: Scalars['Long']['output'];
  styleVariant?: Maybe<Scalars['String']['output']>;
};

export type SaveStyleGroupingInput = {
  brandPublicId: Scalars['String']['input'];
  collectionPublicId?: InputMaybe<Array<Scalars['Long']['input']>>;
  isDeleted: Scalars['Boolean']['input'];
  isInactive: Scalars['Boolean']['input'];
  styleGroupingName: Scalars['String']['input'];
  styleGroupingPublicId?: InputMaybe<Scalars['String']['input']>;
  styleGroupingTypePublicId: Scalars['String']['input'];
};

export type SaveStyleVariantInput = {
  styleNumber: Scalars['Long']['input'];
  styleVariantName: Scalars['String']['input'];
  styleVariantTypePublicId: Scalars['Long']['input'];
  userNumber: Scalars['UUID']['input'];
  variantPublicId?: InputMaybe<Scalars['Long']['input']>;
};

export type SaveVariantInput = {
  brandPublicId: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  isDeleted: Scalars['Boolean']['input'];
  publicId?: InputMaybe<Scalars['Long']['input']>;
  styleVariantTypePublicId?: InputMaybe<Scalars['Long']['input']>;
  userNumber: Scalars['UUID']['input'];
  variantName: Scalars['String']['input'];
};

/**  Sorting for styleSearch. Attributes: styleName, styleNumber, buyerName, expectedSupplier. Direction: ASC or DESC. */
export type SortByInput = {
  sortByAttribute?: InputMaybe<Scalars['String']['input']>;
  sortByDirection?: InputMaybe<Scalars['String']['input']>;
};

export type StyleAttribute = {
  __typename?: 'StyleAttribute';
  styleAttributeName?: Maybe<Scalars['String']['output']>;
  styleAttributeNumber?: Maybe<Scalars['String']['output']>;
};

/**  A single association between a style and a collection it belongs to.  */
export type StyleCollection = {
  __typename?: 'StyleCollection';
  /**  Brand number of the style in this association.  */
  brandNumber?: Maybe<Scalars['String']['output']>;
  /**  UUID derived from the capsule number associated with this style-collection link, if any.  */
  capsuleNumber?: Maybe<Scalars['UUID']['output']>;
  /**  The collection this style belongs to, with its full details.  */
  collection?: Maybe<Collection>;
  /**  Strategic type number associated with this style-collection link, if any.  */
  strategicTypeNumber?: Maybe<Scalars['Long']['output']>;
  /**  Unique identifier of this style-collection association.  */
  styleCollectionNumber: Scalars['Long']['output'];
  /**  The style number in this association.  */
  styleNumber?: Maybe<Scalars['Long']['output']>;
  /**  UUID derived from the theme number associated with this style-collection link, if any.  */
  themeNumber?: Maybe<Scalars['UUID']['output']>;
};

/**  A page of styleCollection results, following the Relay cursor connection pattern.  */
export type StyleCollectionConnection = {
  __typename?: 'StyleCollectionConnection';
  /**  The style-collection rows for the current page.  */
  edges?: Maybe<Array<Maybe<StyleCollectionEdge>>>;
  /**  Cursor and paging metadata for fetching the next or previous page.  */
  pageInfo?: Maybe<PageInfo>;
  /**  Total number of matching style-collection rows across all pages, ignoring cursor position.  */
  totalCount: Scalars['Long']['output'];
};

/**  One style-collection row paired with its pagination cursor.  */
export type StyleCollectionEdge = {
  __typename?: 'StyleCollectionEdge';
  /**  Opaque cursor identifying this row's position, for use as the `after` argument on a subsequent query.  */
  cursor: Scalars['String']['output'];
  /**  The style-collection association for this edge.  */
  node: StyleCollection;
};

/**
 * Filter criteria for the styleCollection query.
 * At least one of collectionNumbers or styleNumbers must be provided.
 */
export type StyleCollectionFilterInput = {
  /**  Filter by one or more collection numbers.  */
  collectionNumbers?: InputMaybe<Array<Scalars['Long']['input']>>;
  /**  Filter by one or more style numbers — use this to get all collections a style belongs to.  */
  styleNumbers?: InputMaybe<Array<Scalars['Long']['input']>>;
};

export type StyleCollectionInfo = {
  __typename?: 'StyleCollectionInfo';
  collectionName?: Maybe<Scalars['String']['output']>;
  collectionNumber: Scalars['Long']['output'];
  collectionTerm?: Maybe<Scalars['String']['output']>;
  hasPurchaseOrder?: Maybe<Scalars['Boolean']['output']>;
};

/** The result of attempting to remove a collection from a style. */
export type StyleCollectionResponse = {
  __typename?: 'StyleCollectionResponse';
  messages?: Maybe<Array<Scalars['String']['output']>>;
  status: Scalars['String']['output'];
  styleNumber: Scalars['Long']['output'];
};

export type StyleConnection = {
  __typename?: 'StyleConnection';
  edges?: Maybe<Array<StyleEdge>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Int']['output'];
};

export enum StyleCopyRelationType {
  /**  The source style becomes the body type of the copy; recorded in styleCorrelation. */
  BodyType = 'BODY_TYPE',
  /**  The source style becomes the parent of the copied design clone. */
  DesignClone = 'DESIGN_CLONE',
  /**  Plain 1:1 copy; no styleCorrelation row is created. */
  OneToOne = 'ONE_TO_ONE'
}

export type StyleCreationInput = {
  barcodeLabelNumber?: InputMaybe<Scalars['Long']['input']>;
  /**  Body type number, stored as a style attribute. */
  bodyTypeNumber?: InputMaybe<Scalars['Long']['input']>;
  brandNumber: Scalars['String']['input'];
  buyerEmail: Scalars['String']['input'];
  closureNumber?: InputMaybe<Scalars['Long']['input']>;
  collectionNumber: Scalars['Long']['input'];
  /**  Expected factory number. Stored on the primary style supplier; not sent to StyleCmd. */
  expectedFactoryNumber?: InputMaybe<Scalars['String']['input']>;
  /**  Expected supplier number. Stored as the primary style supplier and sent to StyleCmd. A different supplier demotes the previous primary supplier to secondary. */
  expectedSupplierNumber?: InputMaybe<Scalars['String']['input']>;
  fitNumber?: InputMaybe<Scalars['Long']['input']>;
  genderNumber: Scalars['Long']['input'];
  /**  Whether the style is licensed goods. Defaults to false when omitted. */
  isLicensedGoods?: InputMaybe<Scalars['Boolean']['input']>;
  /**  Whether the style is polybagged. Sent to StyleCmd as poly bagged flag. */
  isPolybagged?: InputMaybe<Scalars['Boolean']['input']>;
  /**  Level number of the style. */
  levelNumber?: InputMaybe<Scalars['Long']['input']>;
  masterSubcategoryNumber: Scalars['String']['input'];
  neckNumber?: InputMaybe<Scalars['Long']['input']>;
  productLineNumber: Scalars['String']['input'];
  purchaseDivisionNumber: Scalars['Long']['input'];
  /**  Size type public id, stored as a style attribute. */
  sizeTypePublicId?: InputMaybe<Scalars['UUID']['input']>;
  sleeveNumber?: InputMaybe<Scalars['Long']['input']>;
  soldInPieces?: InputMaybe<Scalars['Int']['input']>;
  strategicTypeNumber?: InputMaybe<Scalars['Long']['input']>;
  styleName: Scalars['String']['input'];
  styleNumber?: InputMaybe<Scalars['Long']['input']>;
};

export type StyleEdge = {
  __typename?: 'StyleEdge';
  cursor: Scalars['String']['output'];
  node: StyleSearchResult;
};

export type StyleFilterInput = {
  bodyTypeNumbers?: InputMaybe<Array<Scalars['Long']['input']>>;
  brandNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  businessModelTypeNumbers?: InputMaybe<Array<Scalars['Long']['input']>>;
  buyerNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  changedBy?: InputMaybe<Scalars['String']['input']>;
  closureNumbers?: InputMaybe<Array<Scalars['Long']['input']>>;
  collectionNumbers?: InputMaybe<Array<Scalars['Long']['input']>>;
  eanNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  factoryNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  fitNumbers?: InputMaybe<Array<Scalars['Long']['input']>>;
  genderNumbers?: InputMaybe<Array<Scalars['Long']['input']>>;
  isLicensedGoods?: InputMaybe<Scalars['Boolean']['input']>;
  levelNumbers?: InputMaybe<Array<Scalars['Long']['input']>>;
  mainColourNumbers?: InputMaybe<Array<Scalars['Long']['input']>>;
  masterColourNumbers?: InputMaybe<Array<Scalars['Long']['input']>>;
  masterStyleCategoryNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  masterStyleSubcategoryNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  moreSustainableChoiceNumbers?: InputMaybe<Array<Scalars['Long']['input']>>;
  neckNumbers?: InputMaybe<Array<Scalars['Long']['input']>>;
  productLineNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  purchaseDivisionNumbers?: InputMaybe<Array<Scalars['Long']['input']>>;
  salesThemeNumbers?: InputMaybe<Array<Scalars['Long']['input']>>;
  sizeTypePublicIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sleeveNumbers?: InputMaybe<Array<Scalars['Long']['input']>>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  styleNumbers?: InputMaybe<Array<Scalars['Long']['input']>>;
  styleNumbersOrNames?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  variantNumbers?: InputMaybe<Array<Scalars['Long']['input']>>;
};

export type StyleGroupingCollectionResponse = {
  __typename?: 'StyleGroupingCollectionResponse';
  collectionName?: Maybe<Scalars['String']['output']>;
  collectionNumber: Scalars['Long']['output'];
};

export type StyleGroupingResponse = {
  __typename?: 'StyleGroupingResponse';
  changedByName?: Maybe<Scalars['String']['output']>;
  changedDate?: Maybe<Scalars['String']['output']>;
  collections?: Maybe<Array<StyleGroupingCollectionResponse>>;
  createdByName: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  isCollectionLinked: Scalars['Boolean']['output'];
  isInactive: Scalars['Boolean']['output'];
  isMultiple: Scalars['Boolean']['output'];
  styleGroupingName: Scalars['String']['output'];
  styleGroupingPublicId: Scalars['String']['output'];
  styleGroupingTypeName: Scalars['String']['output'];
  styleGroupingTypePublicId: Scalars['String']['output'];
};

export enum StyleGroupingTypeCode {
  DesignTheme = 'DESIGN_THEME',
  GroupName = 'GROUP_NAME',
  Levels = 'LEVELS',
  Purpose = 'PURPOSE',
  SalesRequest = 'SALES_REQUEST',
  SalesTheme = 'SALES_THEME'
}

export type StyleGroupingTypeResponse = {
  __typename?: 'StyleGroupingTypeResponse';
  isCollectionLinked: Scalars['Boolean']['output'];
  styleGroupingTypeName: Scalars['String']['output'];
  styleGroupingTypePublicId: Scalars['String']['output'];
};

export type StyleNameException = {
  __typename?: 'StyleNameException';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  exceptionRegex?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  number: Scalars['UUID']['output'];
};

export type StyleOptionCollectionPicture = {
  __typename?: 'StyleOptionCollectionPicture';
  businessModelName?: Maybe<Scalars['String']['output']>;
  businessModelPublicId?: Maybe<Scalars['Long']['output']>;
  collectionName: Scalars['String']['output'];
  collectionPublicId: Scalars['Long']['output'];
};

export type StyleOptionPicture = {
  __typename?: 'StyleOptionPicture';
  assetVersion: AssetVersion;
  styleOptionNumber: Scalars['Long']['output'];
  styleOptionPictureNumber: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type StylePicture = {
  __typename?: 'StylePicture';
  count: Scalars['Int']['output'];
  images: Array<Picture>;
  masterColourName: Scalars['String']['output'];
  masterColourPublicId: Scalars['Long']['output'];
  styleOptionCollection: Array<StyleOptionCollectionPicture>;
  styleOptionPublicId: Scalars['Long']['output'];
};

/**  Style price for a single country. */
export type StylePrice = {
  __typename?: 'StylePrice';
  countryCode: Scalars['String']['output'];
  currencyCode: Scalars['String']['output'];
  /** Retail-to-wholesale price ratio rounded to one decimal place. */
  markup?: Maybe<Scalars['Float']['output']>;
  retailPrice?: Maybe<Scalars['Float']['output']>;
  wholesalePrice?: Maybe<Scalars['Float']['output']>;
};

export type StyleResponse = {
  __typename?: 'StyleResponse';
  barcodeLabelNumber?: Maybe<Scalars['Long']['output']>;
  bodyType?: Maybe<StyleAttribute>;
  brandNumber: Scalars['String']['output'];
  buyer: User;
  changedBy?: Maybe<User>;
  changedDate?: Maybe<Scalars['String']['output']>;
  closure?: Maybe<StyleAttribute>;
  collectionNumber?: Maybe<Scalars['Long']['output']>;
  createdBy: User;
  createdDate: Scalars['String']['output'];
  /**  Factory of the primary supplier, resolved to its name. */
  expectedFactory?: Maybe<StyleAttribute>;
  /**  Primary supplier of the style, resolved to its name. */
  expectedSupplier?: Maybe<StyleAttribute>;
  fit?: Maybe<StyleAttribute>;
  gender?: Maybe<StyleAttribute>;
  /**  Base fields  */
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isLicensedGoods?: Maybe<Scalars['Boolean']['output']>;
  isPolybagged?: Maybe<Scalars['Boolean']['output']>;
  level?: Maybe<StyleAttribute>;
  masterStyleGroupNumber?: Maybe<Scalars['String']['output']>;
  masterStyleSubgroupNumber?: Maybe<Scalars['String']['output']>;
  neck?: Maybe<StyleAttribute>;
  /**  Main front and back pictures of the style. */
  pictures?: Maybe<Array<Picture>>;
  /**  German (DEU) price of the style. */
  price?: Maybe<StylePrice>;
  productLineNumber: Scalars['String']['output'];
  purchaseDivisionNumber: Scalars['Long']['output'];
  sizeTypePublicId?: Maybe<Scalars['UUID']['output']>;
  sleeve?: Maybe<StyleAttribute>;
  soldInPieces?: Maybe<Scalars['Long']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  /**  Commercial description shown to customers (sales description). */
  styleCommercialDescription?: Maybe<Scalars['String']['output']>;
  styleName: Scalars['String']['output'];
  /**  Style fields  */
  styleNumber: Scalars['Long']['output'];
};

export type StyleSearchResult = {
  __typename?: 'StyleSearchResult';
  bodyType?: Maybe<Scalars['String']['output']>;
  buyerName?: Maybe<Scalars['String']['output']>;
  collections?: Maybe<Array<StyleCollectionInfo>>;
  factoryNumbers?: Maybe<Array<StyleAttribute>>;
  pictures?: Maybe<Array<StyleOptionPicture>>;
  status?: Maybe<Scalars['String']['output']>;
  styleName?: Maybe<Scalars['String']['output']>;
  styleNumber: Scalars['Long']['output'];
  supplierNumbers?: Maybe<Array<StyleAttribute>>;
};

/**  Supported lifecycle statuses for a style.  */
export enum StyleStatus {
  /**  Style is active.  */
  Active = 'ACTIVE',
  /**  Style is below the minimum threshold.  */
  BelowMinimum = 'BELOW_MINIMUM',
  /**  Style is inactive.  */
  Inactive = 'INACTIVE'
}

export type StyleSupplier = {
  factoryPublicId?: InputMaybe<Scalars['String']['input']>;
  isDeleted: Scalars['Boolean']['input'];
  isPrimary: Scalars['Boolean']['input'];
  styleSupplierPublicId?: InputMaybe<Scalars['UUID']['input']>;
  supplierPublicId: Scalars['String']['input'];
};

export type StyleSupplierInput = {
  styleNumber: Scalars['Long']['input'];
  styleSuppliers: Array<StyleSupplier>;
  userId: Scalars['UUID']['input'];
};

export type StyleSupplierResponse = {
  __typename?: 'StyleSupplierResponse';
  factoryPublicId?: Maybe<Scalars['String']['output']>;
  isPrimary: Scalars['Boolean']['output'];
  styleSupplierPublicId: Scalars['UUID']['output'];
  supplierPublicId: Scalars['String']['output'];
};

export type StyleVariant = {
  __typename?: 'StyleVariant';
  styleVariantPublicId: Scalars['Long']['output'];
  styleVariantTypeName?: Maybe<Scalars['String']['output']>;
  variantName: Scalars['String']['output'];
  variantText?: Maybe<Scalars['String']['output']>;
};

export type StyleVariantTypeResponse = {
  __typename?: 'StyleVariantTypeResponse';
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  publicId: Scalars['Long']['output'];
  styleVariantTypeName: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  email?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
  userNumber?: Maybe<Scalars['String']['output']>;
};

export type VariantLibrary = {
  __typename?: 'VariantLibrary';
  styleVariantTypeName?: Maybe<Scalars['String']['output']>;
  variantName: Scalars['String']['output'];
  variantPublicId: Scalars['Long']['output'];
};

export type VariantResponse = {
  __typename?: 'VariantResponse';
  brandPublicId: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isDeletable: Scalars['Boolean']['output'];
  publicId: Scalars['Long']['output'];
  styleVariantType?: Maybe<StyleVariantTypeResponse>;
  user: User;
  variantName: Scalars['String']['output'];
};

export type VariantsAvailableForStyle = {
  __typename?: 'VariantsAvailableForStyle';
  styleVariants: Array<Maybe<StyleVariant>>;
  variantLibraries: Array<Maybe<VariantLibrary>>;
};

export type WriterStyleEan = {
  __typename?: 'WriterStyleEan';
  changedByEmail?: Maybe<Scalars['String']['output']>;
  changedDate?: Maybe<Scalars['DateTime']['output']>;
  createdByEmail?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  eanNumber?: Maybe<Scalars['String']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  lengthNumber?: Maybe<Scalars['Long']['output']>;
  masterColourNumber: Scalars['Long']['output'];
  sizeNumber: Scalars['Long']['output'];
  styleEanNumber: Scalars['Long']['output'];
  styleNumber: Scalars['Long']['output'];
  styleVariantNumber?: Maybe<Scalars['Long']['output']>;
};

export type WriterStyleOption = {
  __typename?: 'WriterStyleOption';
  businessModelNumber?: Maybe<Scalars['Long']['output']>;
  changedByEmail?: Maybe<Scalars['String']['output']>;
  changedDate?: Maybe<Scalars['DateTime']['output']>;
  createdByEmail?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  externalReference?: Maybe<Scalars['String']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  isInactive: Scalars['Boolean']['output'];
  masterColourNumber: Scalars['Long']['output'];
  styleNumber: Scalars['Long']['output'];
  styleOptionNumber: Scalars['Long']['output'];
  styleVariantNumber?: Maybe<Scalars['Long']['output']>;
};

export type WriterStyleOptionCollection = {
  __typename?: 'WriterStyleOptionCollection';
  businessModelNumber?: Maybe<Scalars['Long']['output']>;
  changedByEmail?: Maybe<Scalars['String']['output']>;
  changedDate?: Maybe<Scalars['DateTime']['output']>;
  collectionNumber: Scalars['Long']['output'];
  createdByEmail?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  isInactive: Scalars['Boolean']['output'];
  sizeCount?: Maybe<Scalars['Long']['output']>;
  styleOptionCollectionNumber: Scalars['Long']['output'];
  styleOptionNumber: Scalars['Long']['output'];
};

export type WriterStyleOptionCollectionStyleEan = {
  __typename?: 'WriterStyleOptionCollectionStyleEan';
  changedByEmail?: Maybe<Scalars['String']['output']>;
  changedDate?: Maybe<Scalars['DateTime']['output']>;
  createdByEmail?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  isInactive: Scalars['Boolean']['output'];
  styleEanNumber: Scalars['Long']['output'];
  styleOptionCollectionNumber: Scalars['Long']['output'];
  styleOptionCollectionStyleEanNumber: Scalars['Long']['output'];
};

export type WriterStyleOptionsInCollectionsResponse = {
  __typename?: 'WriterStyleOptionsInCollectionsResponse';
  styleEans: Array<WriterStyleEan>;
  styleOptionCollectionStyleEans: Array<WriterStyleOptionCollectionStyleEan>;
  styleOptionCollections: Array<WriterStyleOptionCollection>;
  styleOptions: Array<WriterStyleOption>;
  styleVariants: Array<WriterStyleVariant>;
};

export type WriterStyleVariant = {
  __typename?: 'WriterStyleVariant';
  changedByEmail?: Maybe<Scalars['String']['output']>;
  changedDate?: Maybe<Scalars['DateTime']['output']>;
  createdByEmail?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  styleVariantName?: Maybe<Scalars['String']['output']>;
  styleVariantNumber: Scalars['Long']['output'];
  styleVariantSequenceNumber?: Maybe<Scalars['Long']['output']>;
  styleVariantTypeNumber?: Maybe<Scalars['Long']['output']>;
  variantPublicId?: Maybe<Scalars['Long']['output']>;
  variantText?: Maybe<Scalars['String']['output']>;
};

export type GetAllStyleOptionsInCollection = {
  __typename?: 'getAllStyleOptionsInCollection';
  collectionName?: Maybe<Scalars['String']['output']>;
  collectionNumber: Scalars['Long']['output'];
  styleOptionCollections: Array<StyleOptionCollection>;
};

export type SaveStyleOptionsInCollectionsInput = {
  collectionNumber: Scalars['Long']['input'];
  styleOptionCollections: Array<StyleOptionCollectionInput>;
};

export type StyleOptionCollection = {
  __typename?: 'styleOptionCollection';
  businessModelNumber: Scalars['Long']['output'];
  isInactive: Scalars['Boolean']['output'];
  masterColourHexCode: Scalars['String']['output'];
  masterColourName: Scalars['String']['output'];
  masterColourNumber: Scalars['Long']['output'];
  styleOptionCollectionNumber: Scalars['Long']['output'];
  styleOptionCollectionStyleEans: Array<StyleOptionCollectionStyleEan>;
  styleOptionNumber: Scalars['Long']['output'];
  styleVariant?: Maybe<StyleVariant>;
};

export type StyleOptionCollectionInput = {
  businessModelNumber: Scalars['Long']['input'];
  isDeleted: Scalars['Boolean']['input'];
  isInactive: Scalars['Boolean']['input'];
  masterColourNumber: Scalars['Long']['input'];
  styleOptionCollectionNumber?: InputMaybe<Scalars['Long']['input']>;
  styleOptionCollectionStyleEans: Array<StyleOptionCollectionStyleEanInput>;
  variant?: InputMaybe<VariantInput>;
};

export type StyleOptionCollectionStyleEan = {
  __typename?: 'styleOptionCollectionStyleEan';
  isDeleted: Scalars['Boolean']['output'];
  lengthName?: Maybe<Scalars['String']['output']>;
  lengthNumber?: Maybe<Scalars['Long']['output']>;
  sizeName: Scalars['String']['output'];
  sizeNumber: Scalars['Long']['output'];
  styleOptionCollectionStyleEanNumber: Scalars['Long']['output'];
};

export type StyleOptionCollectionStyleEanInput = {
  isDeleted: Scalars['Boolean']['input'];
  isInactive: Scalars['Boolean']['input'];
  lengthNumber?: InputMaybe<Scalars['Long']['input']>;
  sizeNumber: Scalars['Long']['input'];
  styleOptionCollectionStyleEanNumber?: InputMaybe<Scalars['Long']['input']>;
};

export type StyleVariantInput = {
  styleVariantPublicId?: InputMaybe<Scalars['Long']['input']>;
  variantPublicId?: InputMaybe<Scalars['Long']['input']>;
};

export type VariantInput = {
  styleVariantPublicId?: InputMaybe<Scalars['Long']['input']>;
  variantPublicId?: InputMaybe<Scalars['Long']['input']>;
};

export type StyleAttributeFragmentFragment = { __typename?: 'StyleAttribute', styleAttributeName?: string | null, styleAttributeNumber?: string | null };

export type GetBusinessModelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBusinessModelsQuery = { __typename?: 'Query', businessModels: Array<{ __typename?: 'BusinessModel', businessModelNumber: number, businessModelDisplayName: string }> };

export type GetStyleEanForStyleQueryVariables = Exact<{
  collectionNumber: Scalars['Long']['input'];
  styleNumbers: Array<Scalars['Long']['input']> | Scalars['Long']['input'];
}>;


export type GetStyleEanForStyleQuery = { __typename?: 'Query', getStyleEanForStyle: Array<{ __typename?: 'SampleStyle', styleNumber: number, styleName: string, productLineNumber: string, masterStyleSubCategoryNumber: string, styleOptions: Array<{ __typename?: 'SampleStyleOption', styleOptionNumber: number, colourName: string, hexCode?: string | null, styleVariant?: string | null, styleEans: Array<{ __typename?: 'SampleStyleEan', styleEanNumber: number, size: { __typename?: 'StyleAttribute', styleAttributeName?: string | null, styleAttributeNumber?: string | null }, length?: { __typename?: 'StyleAttribute', styleAttributeName?: string | null, styleAttributeNumber?: string | null } | null }> }> }> };

export type GetStylesForSampleQueryVariables = Exact<{
  collectionNumber: Scalars['Long']['input'];
  supplierNumber: Scalars['String']['input'];
  filters?: InputMaybe<SampleFilterInput>;
  pagination: PaginationInput;
}>;


export type GetStylesForSampleQuery = { __typename?: 'Query', getStylesForSample?: { __typename?: 'SampleStyleConnection', totalCount: number, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null } | null, edges?: Array<{ __typename?: 'SampleStyleEdge', cursor: string, node: { __typename?: 'SampleStyle', styleNumber: number, styleName: string, styleOptions: Array<{ __typename?: 'SampleStyleOption', styleOptionNumber: number, styleVariant?: string | null, colourName: string, hexCode?: string | null, businessModel: { __typename?: 'BusinessModel', businessModelDisplayName: string } }> } } | null> | null } | null };

export const StyleAttributeFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StyleAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StyleAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"styleAttributeName"}},{"kind":"Field","name":{"kind":"Name","value":"styleAttributeNumber"}}]}}]} as unknown as DocumentNode<StyleAttributeFragmentFragment, unknown>;
export const GetBusinessModelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBusinessModels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessModels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessModelNumber"}},{"kind":"Field","name":{"kind":"Name","value":"businessModelDisplayName"}}]}}]}}]} as unknown as DocumentNode<GetBusinessModelsQuery, GetBusinessModelsQueryVariables>;
export const GetStyleEanForStyleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStyleEanForStyle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"styleNumbers"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getStyleEanForStyle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"collectionNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"styleNumbers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"styleNumbers"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"styleNumber"}},{"kind":"Field","name":{"kind":"Name","value":"styleName"}},{"kind":"Field","name":{"kind":"Name","value":"productLineNumber"}},{"kind":"Field","name":{"kind":"Name","value":"masterStyleSubCategoryNumber"}},{"kind":"Field","name":{"kind":"Name","value":"styleOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"styleOptionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"colourName"}},{"kind":"Field","name":{"kind":"Name","value":"hexCode"}},{"kind":"Field","name":{"kind":"Name","value":"styleVariant"}},{"kind":"Field","name":{"kind":"Name","value":"styleEans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"styleEanNumber"}},{"kind":"Field","name":{"kind":"Name","value":"size"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StyleAttributeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"length"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StyleAttributeFragment"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StyleAttributeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StyleAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"styleAttributeName"}},{"kind":"Field","name":{"kind":"Name","value":"styleAttributeNumber"}}]}}]} as unknown as DocumentNode<GetStyleEanForStyleQuery, GetStyleEanForStyleQueryVariables>;
export const GetStylesForSampleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStylesForSample"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supplierNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SampleFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getStylesForSample"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"collectionNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"supplierNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supplierNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"styleNumber"}},{"kind":"Field","name":{"kind":"Name","value":"styleName"}},{"kind":"Field","name":{"kind":"Name","value":"styleOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"styleOptionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"styleVariant"}},{"kind":"Field","name":{"kind":"Name","value":"businessModel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessModelDisplayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"colourName"}},{"kind":"Field","name":{"kind":"Name","value":"hexCode"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetStylesForSampleQuery, GetStylesForSampleQueryVariables>;
